import { profileAssignmentStatusOptions } from '../../helpers/constants';
import { Building } from 'react-bootstrap-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const getStatusColor = status => {
  const statusOption = profileAssignmentStatusOptions.find(option => option.value === status);
  return statusOption ? statusOption.selectedBgColor : '#6c757d'; // default gray
};

const RelatedApartmentStatus = ({ relatedApartments = [], apartmentProfiles = [] }) => {
  return (
    <div>
      {relatedApartments?.length > 0 && (
        <div className="d-flex align-items-center flex-wrap">
          <Building size={11} />
          <span className="ms-1">|</span>
          {relatedApartments?.map(apartment => {
            const matchingAssignment = apartment?.profileAssignments?.find(assignment =>
              apartmentProfiles?.some(profile => profile._id === assignment.profile)
            );

            return (
              <div
                key={apartment?._id}
                className={`d-flex justify-content-center align-items-center text-center text-dark py-2`}
              >
                <OverlayTrigger
                  placement="top"
                  rootClose
                  overlay={
                    <Tooltip
                      id={`tooltip-apartment-${apartment._id}`}
                      style={{
                        maxWidth: '300px',
                        wordBreak: 'break-word',
                        opacity: 1
                      }}
                    >
                      {(() => {
                        const apartmentName = `${apartment?.address ? apartment.address + ', ' : ''}${
                          apartment?.city ? apartment.city + ', ' : ''
                        }(₪${apartment?.inputPrice ? apartment.inputPrice.toString() + ' - ' : '-'})${
                          matchingAssignment?.status ? matchingAssignment.status : ''
                        }`;

                        return apartmentName || '';
                      })()}
                    </Tooltip>
                  }
                >
                  <div
                    className="rounded-circle mx-2"
                    style={{
                      width: '10px',
                      height: '10px',
                      backgroundColor: getStatusColor(matchingAssignment?.status),
                      flexShrink: 0,
                      cursor: 'pointer'
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      window.open(
                        `${process.env.REACT_APP_APP_URL}/apartments?apartmentId=${apartment?._id}`,
                        '_blank'
                      );
                    }}
                  />
                </OverlayTrigger>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RelatedApartmentStatus;
